<script setup>
defineProps({
  item: {
    type: Object,
    default: () => ({
      gift: {},
      value: 0
    }),
    required: true
  }
})
</script>

<template>
  <div class="relative">
    <img
      :src="item.gift.imageUrl"
      class="aspect-square block"
      alt="Gift">

    <span class="text-xs font-semibold text-center text-gray-500 absolute left-0 right-0 -bottom-4">
      {{ item.value }}
    </span>
  </div>
</template>